import { Button, Typography } from '~/components';
import { Icon, getTheme, pxToRem, styled } from '~/modules';

const textMain = getTheme('text.main');
const xlSpacing = getTheme('spacing.xl');
const smSpacing = getTheme('spacing.sm');
export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 40%;
  flex: 1;
`;
export const IconComponent = styled(Icon).attrs({
  fontSize: pxToRem(90),
})`
  color: ${textMain};
  opacity: 0.5;
  margin-bottom: ${xlSpacing}px;
`;

export const Title = styled(Typography).attrs({
  variant: 'xxl',
})`
  font-weight: 600;
`;
export const Description = styled(Typography).attrs({
  variant: 'md',
})`
  line-height: 150%;
  margin-top: ${smSpacing}px;
`;

export const ButtonComponent = styled(Button)`
  width: 100%;
  margin: auto;
`;

export const FooterContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${smSpacing}px;
  width: 100%;
`;
